export enum EstimateTemplateAvailabilityScope {
    Public = 0,
    Managed = 1,
    Hidden = 2,
}

export enum EstimateTemplateAvailabilityStatus {
    Draft = 0,
    Published = 1,
    Expired = 2,
    Archived = 3,
}

export enum EstimateTemplateAvailabilityScopeGql {
    Public = 'PUBLIC',
    Managed = 'MANAGED',
    Hidden = 'HIDDEN',
}

export enum EstimateTemplateAvailabilityStatusGql {
    Draft = 'DRAFT',
    Published = 'PUBLISHED',
    Expired = 'EXPIRED',
    Archived = 'ARCHIVED',
}

export class TableConfig {
    // @ts-ignore TS2564
    type: string;
    // @ts-ignore TS2564
    status: string;
    // @ts-ignore TS2564
    search: string;
    // @ts-ignore TS2564
    pageSkip: number;
    // @ts-ignore TS2564
    pageSize: number;
    // @ts-ignore TS2564
    orderBy: string;
    // @ts-ignore TS2564
    orderByDesc: string;
    // @ts-ignore TS2564
    leadId: string;
    // @ts-ignore TS2564
    hideBuiltIn: boolean;
    // @ts-ignore TS2564
    isDeleted: boolean;
    customer?: any;
}
